function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#67BBB0",
  d: "M0,80C0,35.816,35.817,0,80,0c44.184,0,80,35.816,80,80c0,44.183-35.816,80-80,80C35.817,160,0,124.183,0,80 "
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M65.282,71.96c-1.519,0-2.75,1.231-2.75,2.75s1.231,2.75,2.75,2.75h29.437c1.518,0,2.75-1.231,2.75-2.75 s-1.232-2.75-2.75-2.75H65.282z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M94.718,85.441H65.282c-1.519,0-2.75,1.23-2.75,2.75s1.231,2.75,2.75,2.75h29.436 c1.52,0,2.75-1.23,2.75-2.75S96.237,85.441,94.718,85.441"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M94.718,98.924H65.282c-1.519,0-2.75,1.23-2.75,2.75s1.231,2.75,2.75,2.75h29.436 c1.52,0,2.75-1.23,2.75-2.75S96.237,98.924,94.718,98.924"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M107.965,42.25H66.929c-0.184,0-0.366,0.02-0.544,0.055c-0.116,0.023-0.225,0.064-0.334,0.102 c-0.06,0.02-0.121,0.031-0.179,0.056c-0.123,0.051-0.236,0.118-0.349,0.185c-0.041,0.025-0.084,0.041-0.123,0.068 c-0.15,0.1-0.289,0.215-0.416,0.342L50.093,57.947c-0.127,0.127-0.241,0.267-0.342,0.416c-0.03,0.046-0.051,0.098-0.079,0.145 c-0.062,0.106-0.126,0.212-0.174,0.327c-0.027,0.065-0.041,0.135-0.063,0.201c-0.033,0.104-0.073,0.204-0.096,0.313 c-0.035,0.178-0.055,0.36-0.055,0.546V115c0,1.52,1.231,2.75,2.75,2.75h55.93c1.52,0,2.75-1.23,2.75-2.75V45 C110.715,43.48,109.484,42.25,107.965,42.25 M64.179,51.639v5.506h-5.505L64.179,51.639z M105.215,112.25h-50.43V62.645h12.144 c1.519,0,2.75-1.232,2.75-2.75V47.75h35.536V112.25z"
});

var SvgDocumentoAccent = function SvgDocumentoAccent(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "-0.043 -0.474 161 161",
    enableBackground: "new -0.043 -0.474 161 161",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDocumentoAccent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/documento_accent.de363ed9.svg";
export { ForwardRef as ReactComponent };